import {ResourceService} from './resource';

export class PriceGroupItemPriceService extends ResourceService {
	static uri: string = '/api/group/catalog/item-prices/';

	async create(data: IPriceGroupItemPrice, cfg?: ResourceDataRequestConfig): Promise<IPriceGroupItemPrice> {
		return (await this.POST<IPriceGroupItemPrice>(this.url(), data, cfg)).data;
	}

	async delete(id: number, cfg?: ResourceDataRequestConfig): Promise<void> {
		return (await this.DELETE<void>(this.url(id), undefined, cfg)).data;
	}

	async get(id: number, params?: any, cfg?: ResourceQueryRequestConfig): Promise<IPriceGroupItemPrice> {
		return (await this.GET<IPriceGroupItemPrice>(this.url(id), params, cfg)).data;
	}

	async list(params?: any, cfg?: ResourceQueryRequestConfig): Promise<IPriceGroupItemPrice[]> {
		return (await this.GET<IPriceGroupItemPrice[]>(this.url(), params, cfg)).data;
	}

	async update(id: number, data: IPriceGroupItemPrice, cfg?: ResourceDataRequestConfig): Promise<IPriceGroupItemPrice> {
		return (await this.PUT<IPriceGroupItemPrice>(this.url(id), data, cfg)).data;
	}
}
